import React, { useContext, useEffect, useState, useRef } from "react";
import { IMaskInput } from "react-imask";
import { Field, useField, useFormikContext, ErrorMessage } from "formik";
import { Context } from "../inc/state";
import Select from "react-select";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

export const Radio = ({ id, label, ...props }) => {
	return (
		<div className="form-check">
			<Field type="radio" id={id} className="form-check-input" {...props} />
			<label className="form-check-label" htmlFor={id}>
				{label}
			</label>
		</div>
	);
};

export const Back = () => {
	const [state, dispatch] = useContext(Context);

	const goBack = () => {
		dispatch({ type: "STEP_BACK" });
	};

	return (
		<button type="button" className="btn btn-light" onClick={goBack}>
			Terug
		</button>
	);
};

export const Actions = () => (
	<div className="mt-5">
		<Back />
		<button type="submit" className="btn btn-primary ms-3">
			Volgende
		</button>
	</div>
);

export const SelectInput = ({ label, ...props }) => {
	const [field, meta, { setValue, setTouched }] = useField(props);
	const required = props.required ? ' required' : '';
	const { options } = props;

	const onChange = ({ value }) => {
		setValue(value);
	};

	return (
		<div className="mb-3">
			{label && (
				<label htmlFor={props.id} className={`form-label${required}`}>
					{label}
				</label>
			)}
			<Select
				defaultValue={options.find((option) => option.value === field.value)}
				options={options}
				onChange={onChange}
				onBlur={setTouched}
				styles={{
					control: (styles) => ({ ...styles, borderRadius: "0px" }),
				}}
				{...props}
			/>
		</div>
	);
};

export const PhoneInputWrapper = ({ label, text, ...props }) => {
	const [field, meta, helpers] = useField(props);
	const required = props.required ? ' required' : '';
	return (
		<div className="mb-3">
			{label && (
				<label htmlFor={props.id} className={`form-label${required}`}>
					{label}
				</label>
			)}
			<PhoneInput
				className={meta.touched && meta.error ? `is-invalid` : ""}
				numberInputProps={{
					className: `form-control${meta.touched && meta.error ? ` is-invalid` : ""}`,
				}}
				{...props}
				{...field}
				placeholder="466900822"
				defaultCountry="BE"
				value={field.value}
				onChange={(value) => {
					helpers.setValue(value);
				}}
			/>
			{meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
			{text && <div className="form-text">{text}</div>}
		</div>
	);
};

export const FieldWrapper = ({ label, text, ...props }) => {
	const [field, meta, { setValue }] = useField(props);
	const required = props.required ? ' required' : '';
	return (
		<div className="mb-3">
			{label && (
				<label htmlFor={props.id} className={`form-label${required}`}>
					{label}
				</label>
			)}
			<input
				className={`form-control${meta.touched && meta.error ? ` is-invalid` : ""}`}
				{...field}
				{...props}
			/>
			{meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
			{text && <div className="form-text">{text}</div>}
		</div>
	);
};

export const YesNo = ({ name, label, ...props }) => {
	const required = props.required ? ' required' : '';
	return (
		<div className="mb-3">
			<label htmlFor={`${name}.0`} className={`form-label${required}`}>
				{label}
			</label>

			{["Ja", "Neen"].map((item, index) => (
				<Radio
					name={name}
					id={`${name}.${index}`}
					key={`${name}.${index}`}
					value={item}
					label={item}
					{...props}
				/>
			))}

			<ErrorMessage name={name}>
				{(msg) => <div className="invalid-feedback d-block">{msg}</div>}
			</ErrorMessage>
		</div>
	);
};

export const Rijksregisternummer = (props) => {
	return <MaskedInput mask="00.00.00-000.00" lazy={false} placeholderChar="#" {...props} />;
};

export const MaskedInput = ({ name, label, ...props }) => {
	const ref = useRef(null);
	const inputRef = useRef(null);
	const [field, meta, { setValue, setTouched }] = useField(name);
	const required = props.required ? ' required' : '';

	return (
		<div className="mb-3">
			<label htmlFor={props.id} className={`form-label${required}`}>
				{label}
			</label>

			<IMaskInput
				ref={ref}
				inputRef={inputRef}
				onAccept={(value, mask) => {
					setValue(value);
				}}
				className={`form-control${meta.touched && meta.error ? ` is-invalid` : ""}`}
				{...field}
				{...props}
			/>

			<ErrorMessage name={name}>
				{(msg) => <div className="invalid-feedback d-block">{msg}</div>}
			</ErrorMessage>
		</div>
	);
};

export const FundName = ({ title, subtitle }) => {
	return (
		<>
			<h4 className="mb-1">{title}</h4>
			<p className="lead mb-4">{subtitle}</p>
		</>
	);
};

export const AutoUpdateValues = () => {
	const { values } = useFormikContext();
	const [state, dispatch] = useContext(Context);

	React.useEffect(() => {
		dispatch({ type: "ADD_DATA", payload: { values: values } });
	}, [values, dispatch]);

	return null;
};

export const DisplayFormikState = ({ values }) => {
	if ("files" in values) {
		values.files = Object.assign({}, values.files);
	}

	return (
		<div style={{ margin: "1rem 0" }}>
			<h3 style={{ fontFamily: "monospace" }} />
			<pre
				style={{
					background: "#f6f8fa",
					fontSize: ".65rem",
					padding: ".5rem",
				}}
			>
				{JSON.stringify(values, null, 2)}
			</pre>
		</div>
	);
};
